export default interface PingAuthTokens {
    accessToken: string;
    refreshToken: string;
    idToken: string;
    expiresIn?: number;
}

export const emptyAuthTokens: PingAuthTokens = {
    accessToken: '',
    refreshToken: '',
    idToken: '',
    expiresIn: 0,
};
